import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "create-card-wrapper" };
import { i18n } from '@/locales';
import { computed, ref, toRefs, watch, } from 'vue';
import InputRow from '@/components/Form/InputRow.vue';
import createDeliveryChargeAreaControlFormRules from '@/form/form-rules/deliveryChargeAreaControl';
import { setLimitedByteText } from '@/utils';
import { validationLimitingValue } from '@/constants';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
const lc = 'views.delivery_charge_area_control.registered_area.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CreateRegisterAreaCard',
    props: {
        handleGetRequestProcess: { type: Function, default: () => { } }
    },
    setup(__props) {
        // 구역 설정 > 구역 추가
        const props = __props;
        const { handleGetRequestProcess, } = toRefs(props);
        const formRules = createDeliveryChargeAreaControlFormRules('form_rules.');
        const { DELIVERY_CHARGE_AREA_NAME_MAX_LENGTH } = validationLimitingValue;
        const currentAreaNameRef = ref(null);
        const currentAreaName = ref('');
        const localeInfo = {
            currentAreaName: {
                label: i18n.t(`${lc}area_name`),
                placeholder: i18n.t('common.input_field_placeholder', {
                    field: i18n.t(`${lc}area_name`),
                }),
            },
            saveButtonText: i18n.t('common.save'),
        };
        const getterCurrentPolygonCoordinateList = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterCurrentPolygonCoordinateList']);
        const getterIsCreateAreaMode = computed(() => vuexStore.getters['deliveryChargeAreaControl/getterIsCreateAreaMode']);
        /**
             * 구역 이름 변경 핸들러
             */
        const handleChangeCurrentAreaName = (_value) => {
            if (_value === null) {
                return;
            }
            const value = _value?.target
                ? _value.target.value
                : _value;
            currentAreaName.value = setLimitedByteText(value.trim(), DELIVERY_CHARGE_AREA_NAME_MAX_LENGTH, currentAreaNameRef.value);
        };
        /**
             * 저장 버튼 클릭 핸들러
             */
        const handleClickSave = async () => {
            if (getterCurrentPolygonCoordinateList.value.length === 0) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t(`${lc}area_coordinate_list_require`),
                });
                return;
            }
            const valid = await currentAreaNameRef.value.validate();
            if (valid.length > 0) {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.form_validation_error'),
                });
                return;
            }
            const areaInfo = {
                areaName: currentAreaName.value,
                coordinateList: getterCurrentPolygonCoordinateList.value,
            };
            const response = await vuexStore.dispatch('deliveryChargeAreaControl/postRegisteredAreaList', areaInfo);
            if (response.isSuccess) {
                handleGetRequestProcess.value();
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${lc}delivery_charge_area_config_complete.create`),
                });
            }
            else {
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: response.message,
                });
            }
            currentAreaName.value = '';
            vuexStore.dispatch('deliveryChargeAreaControl/setIsCreateAreaMode', false);
        };
        watch(() => getterIsCreateAreaMode.value, (value) => {
            if (!value) {
                currentAreaNameRef.value.reset();
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(InputRow, {
                    label: localeInfo.currentAreaName.label,
                    "is-required": "",
                    "is-vertical-label": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            class: "cy-current-area-name-input",
                            ref_key: "currentAreaNameRef",
                            ref: currentAreaNameRef,
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "auto",
                            "validate-on-blur": "",
                            placeholder: localeInfo.currentAreaName.placeholder,
                            rules: _unref(formRules).currentAreaName.value,
                            oninput: "javascript: this.value = this.value.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9]/g, '');",
                            "model-value": currentAreaName.value,
                            onBlur: _cache[0] || (_cache[0] = (value) => handleChangeCurrentAreaName(value)),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => handleChangeCurrentAreaName(value))
                        }, null, 8 /* PROPS */, ["placeholder", "rules", "model-value"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["label"]),
                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                    class: "cy-save-button",
                    onClick: handleClickSave
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(localeInfo.saveButtonText), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                })), [
                    [
                        _directive_btn_style,
                        void 0,
                        "config",
                        {
                            primary: true,
                            "width-fill": true
                        }
                    ]
                ])
            ]));
        };
    }
});
